import { useTranslation } from '@rhino-project/core/i18n';
import { Card } from '@heroui/react';
import type { RecordEntry } from '../../utils/standings';

type RecordCardProps = {
  entries: RecordEntry[];
};

export const RecordCard = ({ entries }: RecordCardProps) => {
  const { t } = useTranslation();

  // The row's font scales with the card (cqw) so the 7-entry 3pt/custom record
  // fits the tile at any width, capped at the standard headline size. Legends,
  // dashes, and gaps are em-based so they shrink in proportion; below the rem
  // floor the row wraps instead of clipping (dashes travel with their entry).
  const fluidSize =
    entries.length > 5
      ? 'text-[clamp(0.875rem,6.5cqw,1.5rem)]'
      : 'text-[clamp(0.875rem,9.5cqw,1.5rem)]';

  return (
    <Card className="text-center">
      <div className="@container w-full">
        <div
          className={`flex flex-wrap items-end justify-center gap-y-1 ${fluidSize}`}
        >
          {entries.map((entry, index) => (
            <div key={entry.key} className="flex items-end">
              {index > 0 && (
                <span className="font-bold leading-none mx-[0.3em]">-</span>
              )}
              <div className="flex flex-col items-center">
                <span className="text-[0.42em] font-medium uppercase text-muted leading-none mb-[0.4em]">
                  {entry.label}
                </span>
                <span className="font-bold tabular-nums leading-none">
                  {entry.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <p className="text-xs text-muted uppercase mt-1">
        {t('frontend.messages.record')}
      </p>
    </Card>
  );
};
